export const dataDynamic = {
  17: {
    statistics: {
      goalsScored: 11,
      goalsConceded: 3,
      ownGoals: 1,
      assists: 7,
      shots: 66,
      penaltyGoals: 1,
      penaltiesTaken: 1,
      freeKickGoals: 0,
      freeKickShots: 2,
      goalsFromInsideTheBox: 7,
      goalsFromOutsideTheBox: 4,
      shotsFromInsideTheBox: 44,
      shotsFromOutsideTheBox: 22,
      headedGoals: 0,
      leftFootGoals: 9,
      rightFootGoals: 2,
      bigChances: 13,
      bigChancesCreated: 12,
      bigChancesMissed: 6,
      shotsOnTarget: 25,
      shotsOffTarget: 25,
      blockedScoringAttempt: 16,
      successfulDribbles: 41,
      dribbleAttempts: 67,
      corners: 36,
      hitWoodwork: 4,
      fastBreaks: 3,
      fastBreakGoals: 0,
      fastBreakShots: 3,
      averageBallPossession: 62.25,
      totalPasses: 2560,
      accuratePasses: 2332,
      accuratePassesPercentage: 91.09375,
      totalOwnHalfPasses: 920,
      accurateOwnHalfPasses: 867,
      accurateOwnHalfPassesPercentage: 94.239130434783,
      totalOppositionHalfPasses: 1705,
      accurateOppositionHalfPasses: 1480,
      accurateOppositionHalfPassesPercentage: 86.803519061584,
      totalLongBalls: 102,
      accurateLongBalls: 75,
      accurateLongBallsPercentage: 73.529411764706,
      totalCrosses: 65,
      accurateCrosses: 15,
      accurateCrossesPercentage: 23.076923076923,
      cleanSheets: 1,
      tackles: 57,
      interceptions: 28,
      saves: 10,
      errorsLeadingToGoal: 2,
      errorsLeadingToShot: 2,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 55,
      clearancesOffLine: 0,
      lastManTackles: 2,
      totalDuels: 300,
      duelsWon: 161,
      duelsWonPercentage: 53.666666666667,
      totalGroundDuels: 247,
      groundDuelsWon: 138,
      groundDuelsWonPercentage: 55.87044534413,
      totalAerialDuels: 53,
      aerialDuelsWon: 23,
      aerialDuelsWonPercentage: 43.396226415094,
      possessionLost: 401,
      offsides: 6,
      fouls: 25,
      yellowCards: 8,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.3696428571429,
      accurateFinalThirdPassesAgainst: 267,
      accurateOppositionHalfPassesAgainst: 523,
      accurateOwnHalfPassesAgainst: 812,
      accuratePassesAgainst: 1318,
      bigChancesAgainst: 4,
      bigChancesCreatedAgainst: 3,
      bigChancesMissedAgainst: 2,
      clearancesAgainst: 95,
      cornersAgainst: 11,
      crossesSuccessfulAgainst: 17,
      crossesTotalAgainst: 50,
      dribbleAttemptsTotalAgainst: 43,
      dribbleAttemptsWonAgainst: 19,
      errorsLeadingToGoalAgainst: 4,
      errorsLeadingToShotAgainst: 1,
      hitWoodworkAgainst: 3,
      interceptionsAgainst: 35,
      keyPassesAgainst: 22,
      longBallsSuccessfulAgainst: 75,
      longBallsTotalAgainst: 163,
      offsidesAgainst: 4,
      redCardsAgainst: 0,
      shotsAgainst: 29,
      shotsBlockedAgainst: 8,
      shotsFromInsideTheBoxAgainst: 19,
      shotsFromOutsideTheBoxAgainst: 10,
      shotsOffTargetAgainst: 10,
      shotsOnTargetAgainst: 11,
      blockedScoringAttemptAgainst: 8,
      tacklesAgainst: 68,
      totalFinalThirdPassesAgainst: 355,
      oppositionHalfPassesTotalAgainst: 689,
      ownHalfPassesTotalAgainst: 904,
      totalPassesAgainst: 1543,
      yellowCardsAgainst: 8,
      throwIns: 68,
      goalKicks: 15,
      ballRecovery: 169,
      freeKicks: 40,
      id: 24789,
      matches: 4,
      awardedMatches: 0,
    },
  },
  38: {
    statistics: {
      goalsScored: 8,
      goalsConceded: 5,
      ownGoals: 0,
      assists: 7,
      shots: 47,
      penaltyGoals: 0,
      penaltiesTaken: 0,
      freeKickGoals: 0,
      freeKickShots: 2,
      goalsFromInsideTheBox: 7,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 30,
      shotsFromOutsideTheBox: 17,
      headedGoals: 1,
      leftFootGoals: 2,
      rightFootGoals: 5,
      bigChances: 12,
      bigChancesCreated: 10,
      bigChancesMissed: 6,
      shotsOnTarget: 21,
      shotsOffTarget: 14,
      blockedScoringAttempt: 12,
      successfulDribbles: 36,
      dribbleAttempts: 71,
      corners: 16,
      hitWoodwork: 2,
      fastBreaks: 10,
      fastBreakGoals: 2,
      fastBreakShots: 8,
      averageBallPossession: 59.5,
      totalPasses: 2154,
      accuratePasses: 1888,
      accuratePassesPercentage: 87.650882079851,
      totalOwnHalfPasses: 1123,
      accurateOwnHalfPasses: 1037,
      accurateOwnHalfPassesPercentage: 92.341941228851,
      totalOppositionHalfPasses: 1087,
      accurateOppositionHalfPasses: 862,
      accurateOppositionHalfPassesPercentage: 79.300827966881,
      totalLongBalls: 127,
      accurateLongBalls: 72,
      accurateLongBallsPercentage: 56.692913385827,
      totalCrosses: 56,
      accurateCrosses: 11,
      accurateCrossesPercentage: 19.642857142857,
      cleanSheets: 1,
      tackles: 59,
      interceptions: 33,
      saves: 14,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 3,
      penaltiesCommited: 1,
      penaltyGoalsConceded: 0,
      clearances: 66,
      clearancesOffLine: 0,
      lastManTackles: 1,
      totalDuels: 359,
      duelsWon: 175,
      duelsWonPercentage: 48.74651810585,
      totalGroundDuels: 295,
      groundDuelsWon: 146,
      groundDuelsWonPercentage: 49.491525423729,
      totalAerialDuels: 64,
      aerialDuelsWon: 29,
      aerialDuelsWonPercentage: 45.3125,
      possessionLost: 458,
      offsides: 6,
      fouls: 43,
      yellowCards: 16,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.0133333333333,
      accurateFinalThirdPassesAgainst: 266,
      accurateOppositionHalfPassesAgainst: 519,
      accurateOwnHalfPassesAgainst: 689,
      accuratePassesAgainst: 1199,
      bigChancesAgainst: 7,
      bigChancesCreatedAgainst: 5,
      bigChancesMissedAgainst: 4,
      clearancesAgainst: 82,
      cornersAgainst: 18,
      crossesSuccessfulAgainst: 9,
      crossesTotalAgainst: 50,
      dribbleAttemptsTotalAgainst: 67,
      dribbleAttemptsWonAgainst: 38,
      errorsLeadingToGoalAgainst: 0,
      errorsLeadingToShotAgainst: 1,
      hitWoodworkAgainst: 4,
      interceptionsAgainst: 35,
      keyPassesAgainst: 36,
      longBallsSuccessfulAgainst: 75,
      longBallsTotalAgainst: 175,
      offsidesAgainst: 9,
      redCardsAgainst: 0,
      shotsAgainst: 51,
      shotsBlockedAgainst: 14,
      shotsFromInsideTheBoxAgainst: 28,
      shotsFromOutsideTheBoxAgainst: 23,
      shotsOffTargetAgainst: 18,
      shotsOnTargetAgainst: 19,
      blockedScoringAttemptAgainst: 14,
      tacklesAgainst: 68,
      totalFinalThirdPassesAgainst: 403,
      oppositionHalfPassesTotalAgainst: 762,
      ownHalfPassesTotalAgainst: 769,
      totalPassesAgainst: 1481,
      yellowCardsAgainst: 11,
      throwIns: 67,
      goalKicks: 29,
      ballRecovery: 199,
      freeKicks: 51,
      id: 24788,
      matches: 4,
      awardedMatches: 0,
    },
  },
  42: {
    statistics: {
      goalsScored: 6,
      goalsConceded: 1,
      ownGoals: 0,
      assists: 5,
      shots: 45,
      penaltyGoals: 0,
      penaltiesTaken: 0,
      freeKickGoals: 0,
      freeKickShots: 0,
      goalsFromInsideTheBox: 4,
      goalsFromOutsideTheBox: 2,
      shotsFromInsideTheBox: 34,
      shotsFromOutsideTheBox: 11,
      headedGoals: 2,
      leftFootGoals: 2,
      rightFootGoals: 2,
      bigChances: 11,
      bigChancesCreated: 11,
      bigChancesMissed: 8,
      shotsOnTarget: 21,
      shotsOffTarget: 12,
      blockedScoringAttempt: 12,
      successfulDribbles: 35,
      dribbleAttempts: 69,
      corners: 18,
      hitWoodwork: 0,
      fastBreaks: 6,
      fastBreakGoals: 1,
      fastBreakShots: 5,
      averageBallPossession: 46.5,
      totalPasses: 1486,
      accuratePasses: 1239,
      accuratePassesPercentage: 83.378196500673,
      totalOwnHalfPasses: 741,
      accurateOwnHalfPasses: 682,
      accurateOwnHalfPassesPercentage: 92.037786774629,
      totalOppositionHalfPasses: 793,
      accurateOppositionHalfPasses: 567,
      accurateOppositionHalfPassesPercentage: 71.500630517024,
      totalLongBalls: 92,
      accurateLongBalls: 49,
      accurateLongBallsPercentage: 53.260869565217,
      totalCrosses: 48,
      accurateCrosses: 10,
      accurateCrossesPercentage: 20.833333333333,
      cleanSheets: 3,
      tackles: 73,
      interceptions: 37,
      saves: 14,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 5,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 82,
      clearancesOffLine: 0,
      lastManTackles: 1,
      totalDuels: 425,
      duelsWon: 201,
      duelsWonPercentage: 47.294117647059,
      totalGroundDuels: 316,
      groundDuelsWon: 148,
      groundDuelsWonPercentage: 46.835443037975,
      totalAerialDuels: 109,
      aerialDuelsWon: 53,
      aerialDuelsWonPercentage: 48.623853211009,
      possessionLost: 422,
      offsides: 7,
      fouls: 55,
      yellowCards: 12,
      yellowRedCards: 1,
      redCards: 1,
      avgRating: 7.0872727272727,
      accurateFinalThirdPassesAgainst: 405,
      accurateOppositionHalfPassesAgainst: 807,
      accurateOwnHalfPassesAgainst: 634,
      accuratePassesAgainst: 1419,
      bigChancesAgainst: 6,
      bigChancesCreatedAgainst: 3,
      bigChancesMissedAgainst: 5,
      clearancesAgainst: 65,
      cornersAgainst: 20,
      crossesSuccessfulAgainst: 22,
      crossesTotalAgainst: 81,
      dribbleAttemptsTotalAgainst: 76,
      dribbleAttemptsWonAgainst: 36,
      errorsLeadingToGoalAgainst: 0,
      errorsLeadingToShotAgainst: 1,
      hitWoodworkAgainst: 1,
      interceptionsAgainst: 25,
      keyPassesAgainst: 38,
      longBallsSuccessfulAgainst: 80,
      longBallsTotalAgainst: 157,
      offsidesAgainst: 7,
      redCardsAgainst: 0,
      shotsAgainst: 57,
      shotsBlockedAgainst: 20,
      shotsFromInsideTheBoxAgainst: 38,
      shotsFromOutsideTheBoxAgainst: 19,
      shotsOffTargetAgainst: 22,
      shotsOnTargetAgainst: 15,
      blockedScoringAttemptAgainst: 20,
      tacklesAgainst: 79,
      totalFinalThirdPassesAgainst: 503,
      oppositionHalfPassesTotalAgainst: 1031,
      ownHalfPassesTotalAgainst: 719,
      totalPassesAgainst: 1669,
      yellowCardsAgainst: 10,
      throwIns: 59,
      goalKicks: 29,
      ballRecovery: 166,
      freeKicks: 41,
      id: 24638,
      matches: 4,
      awardedMatches: 0,
    },
  },
  44: {
    statistics: {
      goalsScored: 7,
      goalsConceded: 1,
      ownGoals: 0,
      assists: 6,
      shots: 62,
      penaltyGoals: 0,
      penaltiesTaken: 0,
      freeKickGoals: 0,
      freeKickShots: 1,
      goalsFromInsideTheBox: 7,
      goalsFromOutsideTheBox: 0,
      shotsFromInsideTheBox: 49,
      shotsFromOutsideTheBox: 13,
      headedGoals: 1,
      leftFootGoals: 5,
      rightFootGoals: 1,
      bigChances: 17,
      bigChancesCreated: 14,
      bigChancesMissed: 10,
      shotsOnTarget: 21,
      shotsOffTarget: 23,
      blockedScoringAttempt: 18,
      successfulDribbles: 30,
      dribbleAttempts: 73,
      corners: 28,
      hitWoodwork: 3,
      fastBreaks: 6,
      fastBreakGoals: 1,
      fastBreakShots: 5,
      averageBallPossession: 60,
      totalPasses: 2240,
      accuratePasses: 1940,
      accuratePassesPercentage: 86.607142857143,
      totalOwnHalfPasses: 1018,
      accurateOwnHalfPasses: 934,
      accurateOwnHalfPassesPercentage: 91.748526522593,
      totalOppositionHalfPasses: 1285,
      accurateOppositionHalfPasses: 1025,
      accurateOppositionHalfPassesPercentage: 79.766536964981,
      totalLongBalls: 163,
      accurateLongBalls: 79,
      accurateLongBallsPercentage: 48.466257668712,
      totalCrosses: 63,
      accurateCrosses: 19,
      accurateCrossesPercentage: 30.15873015873,
      cleanSheets: 3,
      tackles: 62,
      interceptions: 33,
      saves: 9,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 1,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 71,
      clearancesOffLine: 0,
      lastManTackles: 1,
      totalDuels: 370,
      duelsWon: 178,
      duelsWonPercentage: 48.108108108108,
      totalGroundDuels: 275,
      groundDuelsWon: 120,
      groundDuelsWonPercentage: 43.636363636364,
      totalAerialDuels: 95,
      aerialDuelsWon: 58,
      aerialDuelsWonPercentage: 61.052631578947,
      possessionLost: 503,
      offsides: 3,
      fouls: 50,
      yellowCards: 8,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.1131147540984,
      accurateFinalThirdPassesAgainst: 247,
      accurateOppositionHalfPassesAgainst: 476,
      accurateOwnHalfPassesAgainst: 716,
      accuratePassesAgainst: 1180,
      bigChancesAgainst: 7,
      bigChancesCreatedAgainst: 7,
      bigChancesMissedAgainst: 7,
      clearancesAgainst: 84,
      cornersAgainst: 13,
      crossesSuccessfulAgainst: 12,
      crossesTotalAgainst: 43,
      dribbleAttemptsTotalAgainst: 59,
      dribbleAttemptsWonAgainst: 23,
      errorsLeadingToGoalAgainst: 3,
      errorsLeadingToShotAgainst: 3,
      hitWoodworkAgainst: 0,
      interceptionsAgainst: 32,
      keyPassesAgainst: 21,
      longBallsSuccessfulAgainst: 81,
      longBallsTotalAgainst: 197,
      offsidesAgainst: 12,
      redCardsAgainst: 0,
      shotsAgainst: 28,
      shotsBlockedAgainst: 6,
      shotsFromInsideTheBoxAgainst: 17,
      shotsFromOutsideTheBoxAgainst: 11,
      shotsOffTargetAgainst: 12,
      shotsOnTargetAgainst: 10,
      blockedScoringAttemptAgainst: 6,
      tacklesAgainst: 84,
      totalFinalThirdPassesAgainst: 382,
      oppositionHalfPassesTotalAgainst: 725,
      ownHalfPassesTotalAgainst: 809,
      totalPassesAgainst: 1491,
      yellowCardsAgainst: 14,
      throwIns: 95,
      goalKicks: 18,
      ballRecovery: 201,
      freeKicks: 28,
      id: 24621,
      matches: 4,
      awardedMatches: 0,
    },
  },
  1644: {
    statistics: {
      goalsScored: 16,
      goalsConceded: 3,
      ownGoals: 0,
      assists: 13,
      shots: 75,
      penaltyGoals: 2,
      penaltiesTaken: 2,
      freeKickGoals: 0,
      freeKickShots: 4,
      goalsFromInsideTheBox: 13,
      goalsFromOutsideTheBox: 3,
      shotsFromInsideTheBox: 54,
      shotsFromOutsideTheBox: 21,
      headedGoals: 3,
      leftFootGoals: 5,
      rightFootGoals: 8,
      bigChances: 27,
      bigChancesCreated: 24,
      bigChancesMissed: 16,
      shotsOnTarget: 37,
      shotsOffTarget: 25,
      blockedScoringAttempt: 13,
      successfulDribbles: 34,
      dribbleAttempts: 93,
      corners: 28,
      hitWoodwork: 2,
      fastBreaks: 12,
      fastBreakGoals: 3,
      fastBreakShots: 10,
      averageBallPossession: 67.5,
      totalPasses: 2858,
      accuratePasses: 2629,
      accuratePassesPercentage: 91.987403778866,
      totalOwnHalfPasses: 1345,
      accurateOwnHalfPasses: 1268,
      accurateOwnHalfPassesPercentage: 94.275092936803,
      totalOppositionHalfPasses: 1572,
      accurateOppositionHalfPasses: 1376,
      accurateOppositionHalfPassesPercentage: 87.531806615776,
      totalLongBalls: 124,
      accurateLongBalls: 88,
      accurateLongBallsPercentage: 70.967741935484,
      totalCrosses: 59,
      accurateCrosses: 15,
      accurateCrossesPercentage: 25.423728813559,
      cleanSheets: 1,
      tackles: 74,
      interceptions: 26,
      saves: 9,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 2,
      penaltiesCommited: 1,
      penaltyGoalsConceded: 1,
      clearances: 37,
      clearancesOffLine: 0,
      lastManTackles: 0,
      totalDuels: 352,
      duelsWon: 181,
      duelsWonPercentage: 51.420454545455,
      totalGroundDuels: 300,
      groundDuelsWon: 153,
      groundDuelsWonPercentage: 51,
      totalAerialDuels: 52,
      aerialDuelsWon: 28,
      aerialDuelsWonPercentage: 53.846153846154,
      possessionLost: 444,
      offsides: 6,
      fouls: 36,
      yellowCards: 5,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.2140625,
      accurateFinalThirdPassesAgainst: 222,
      accurateOppositionHalfPassesAgainst: 489,
      accurateOwnHalfPassesAgainst: 606,
      accuratePassesAgainst: 1083,
      bigChancesAgainst: 7,
      bigChancesCreatedAgainst: 6,
      bigChancesMissedAgainst: 6,
      clearancesAgainst: 57,
      cornersAgainst: 8,
      crossesSuccessfulAgainst: 12,
      crossesTotalAgainst: 44,
      dribbleAttemptsTotalAgainst: 52,
      dribbleAttemptsWonAgainst: 21,
      errorsLeadingToGoalAgainst: 0,
      errorsLeadingToShotAgainst: 1,
      hitWoodworkAgainst: 1,
      interceptionsAgainst: 37,
      keyPassesAgainst: 22,
      longBallsSuccessfulAgainst: 94,
      longBallsTotalAgainst: 184,
      offsidesAgainst: 9,
      redCardsAgainst: 0,
      shotsAgainst: 26,
      shotsBlockedAgainst: 6,
      shotsFromInsideTheBoxAgainst: 17,
      shotsFromOutsideTheBoxAgainst: 9,
      shotsOffTargetAgainst: 8,
      shotsOnTargetAgainst: 12,
      blockedScoringAttemptAgainst: 6,
      tacklesAgainst: 91,
      totalFinalThirdPassesAgainst: 322,
      oppositionHalfPassesTotalAgainst: 690,
      ownHalfPassesTotalAgainst: 699,
      totalPassesAgainst: 1345,
      yellowCardsAgainst: 13,
      throwIns: 76,
      goalKicks: 21,
      ballRecovery: 203,
      freeKicks: 45,
      id: 24548,
      matches: 4,
      awardedMatches: 0,
    },
  },
  2672: {
    statistics: {
      goalsScored: 11,
      goalsConceded: 3,
      ownGoals: 0,
      assists: 6,
      shots: 50,
      penaltyGoals: 2,
      penaltiesTaken: 2,
      freeKickGoals: 0,
      freeKickShots: 0,
      goalsFromInsideTheBox: 8,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 43,
      shotsFromOutsideTheBox: 7,
      headedGoals: 0,
      leftFootGoals: 2,
      rightFootGoals: 7,
      bigChances: 11,
      bigChancesCreated: 9,
      bigChancesMissed: 5,
      shotsOnTarget: 23,
      shotsOffTarget: 11,
      blockedScoringAttempt: 16,
      successfulDribbles: 43,
      dribbleAttempts: 83,
      corners: 19,
      hitWoodwork: 2,
      fastBreaks: 2,
      fastBreakGoals: 0,
      fastBreakShots: 2,
      averageBallPossession: 69.333333333333,
      totalPasses: 2111,
      accuratePasses: 1885,
      accuratePassesPercentage: 89.294173377546,
      totalOwnHalfPasses: 1085,
      accurateOwnHalfPasses: 1014,
      accurateOwnHalfPassesPercentage: 93.456221198157,
      totalOppositionHalfPasses: 1074,
      accurateOppositionHalfPasses: 882,
      accurateOppositionHalfPassesPercentage: 82.122905027933,
      totalLongBalls: 104,
      accurateLongBalls: 66,
      accurateLongBallsPercentage: 63.461538461538,
      totalCrosses: 48,
      accurateCrosses: 11,
      accurateCrossesPercentage: 22.916666666667,
      cleanSheets: 1,
      tackles: 41,
      interceptions: 16,
      saves: 3,
      errorsLeadingToGoal: 1,
      errorsLeadingToShot: 2,
      penaltiesCommited: 2,
      penaltyGoalsConceded: 1,
      clearances: 44,
      clearancesOffLine: 0,
      lastManTackles: 0,
      totalDuels: 302,
      duelsWon: 162,
      duelsWonPercentage: 53.64238410596,
      totalGroundDuels: 226,
      groundDuelsWon: 116,
      groundDuelsWonPercentage: 51.327433628319,
      totalAerialDuels: 76,
      aerialDuelsWon: 46,
      aerialDuelsWonPercentage: 60.526315789474,
      possessionLost: 369,
      offsides: 2,
      fouls: 35,
      yellowCards: 5,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.1244444444444,
      accurateFinalThirdPassesAgainst: 110,
      accurateOppositionHalfPassesAgainst: 261,
      accurateOwnHalfPassesAgainst: 419,
      accuratePassesAgainst: 675,
      bigChancesAgainst: 5,
      bigChancesCreatedAgainst: 2,
      bigChancesMissedAgainst: 3,
      clearancesAgainst: 63,
      cornersAgainst: 7,
      crossesSuccessfulAgainst: 5,
      crossesTotalAgainst: 34,
      dribbleAttemptsTotalAgainst: 36,
      dribbleAttemptsWonAgainst: 15,
      errorsLeadingToGoalAgainst: 2,
      errorsLeadingToShotAgainst: 1,
      hitWoodworkAgainst: 3,
      interceptionsAgainst: 38,
      keyPassesAgainst: 16,
      longBallsSuccessfulAgainst: 59,
      longBallsTotalAgainst: 170,
      offsidesAgainst: 3,
      redCardsAgainst: 0,
      shotsAgainst: 24,
      shotsBlockedAgainst: 5,
      shotsFromInsideTheBoxAgainst: 15,
      shotsFromOutsideTheBoxAgainst: 9,
      shotsOffTargetAgainst: 13,
      shotsOnTargetAgainst: 6,
      blockedScoringAttemptAgainst: 5,
      tacklesAgainst: 61,
      totalFinalThirdPassesAgainst: 207,
      oppositionHalfPassesTotalAgainst: 467,
      ownHalfPassesTotalAgainst: 485,
      totalPassesAgainst: 918,
      yellowCardsAgainst: 2,
      throwIns: 61,
      goalKicks: 14,
      ballRecovery: 155,
      freeKicks: 32,
      id: 25143,
      matches: 3,
      awardedMatches: 0,
    },
  },
  2673: {
    statistics: {
      goalsScored: 6,
      goalsConceded: 2,
      ownGoals: 0,
      assists: 5,
      shots: 42,
      penaltyGoals: 1,
      penaltiesTaken: 1,
      freeKickGoals: 0,
      freeKickShots: 0,
      goalsFromInsideTheBox: 5,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 29,
      shotsFromOutsideTheBox: 13,
      headedGoals: 0,
      leftFootGoals: 1,
      rightFootGoals: 5,
      bigChances: 7,
      bigChancesCreated: 5,
      bigChancesMissed: 4,
      shotsOnTarget: 15,
      shotsOffTarget: 13,
      blockedScoringAttempt: 14,
      successfulDribbles: 22,
      dribbleAttempts: 46,
      corners: 21,
      hitWoodwork: 0,
      fastBreaks: 5,
      fastBreakGoals: 2,
      fastBreakShots: 3,
      averageBallPossession: 61.333333333333,
      totalPasses: 1794,
      accuratePasses: 1587,
      accuratePassesPercentage: 88.461538461538,
      totalOwnHalfPasses: 866,
      accurateOwnHalfPasses: 802,
      accurateOwnHalfPassesPercentage: 92.609699769053,
      totalOppositionHalfPasses: 993,
      accurateOppositionHalfPasses: 802,
      accurateOppositionHalfPassesPercentage: 80.765357502518,
      totalLongBalls: 95,
      accurateLongBalls: 47,
      accurateLongBallsPercentage: 49.473684210526,
      totalCrosses: 65,
      accurateCrosses: 17,
      accurateCrossesPercentage: 26.153846153846,
      cleanSheets: 2,
      tackles: 43,
      interceptions: 18,
      saves: 5,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 2,
      penaltiesCommited: 1,
      penaltyGoalsConceded: 1,
      clearances: 70,
      clearancesOffLine: 0,
      lastManTackles: 0,
      totalDuels: 263,
      duelsWon: 140,
      duelsWonPercentage: 53.231939163498,
      totalGroundDuels: 190,
      groundDuelsWon: 93,
      groundDuelsWonPercentage: 48.947368421053,
      totalAerialDuels: 73,
      aerialDuelsWon: 47,
      aerialDuelsWonPercentage: 64.383561643836,
      possessionLost: 356,
      offsides: 3,
      fouls: 34,
      yellowCards: 8,
      yellowRedCards: 1,
      redCards: 1,
      avgRating: 7,
      accurateFinalThirdPassesAgainst: 155,
      accurateOppositionHalfPassesAgainst: 327,
      accurateOwnHalfPassesAgainst: 559,
      accuratePassesAgainst: 880,
      bigChancesAgainst: 3,
      bigChancesCreatedAgainst: 2,
      bigChancesMissedAgainst: 2,
      clearancesAgainst: 75,
      cornersAgainst: 13,
      crossesSuccessfulAgainst: 6,
      crossesTotalAgainst: 59,
      dribbleAttemptsTotalAgainst: 40,
      dribbleAttemptsWonAgainst: 17,
      errorsLeadingToGoalAgainst: 0,
      errorsLeadingToShotAgainst: 0,
      hitWoodworkAgainst: 0,
      interceptionsAgainst: 23,
      keyPassesAgainst: 13,
      longBallsSuccessfulAgainst: 57,
      longBallsTotalAgainst: 122,
      offsidesAgainst: 10,
      redCardsAgainst: 0,
      shotsAgainst: 23,
      shotsBlockedAgainst: 10,
      shotsFromInsideTheBoxAgainst: 15,
      shotsFromOutsideTheBoxAgainst: 8,
      shotsOffTargetAgainst: 6,
      shotsOnTargetAgainst: 7,
      blockedScoringAttemptAgainst: 10,
      tacklesAgainst: 48,
      totalFinalThirdPassesAgainst: 234,
      oppositionHalfPassesTotalAgainst: 527,
      ownHalfPassesTotalAgainst: 612,
      totalPassesAgainst: 1080,
      yellowCardsAgainst: 5,
      throwIns: 50,
      goalKicks: 16,
      ballRecovery: 118,
      freeKicks: 30,
      id: 25118,
      matches: 3,
      awardedMatches: 0,
    },
  },
  2681: {
    statistics: {
      goalsScored: 9,
      goalsConceded: 6,
      ownGoals: 0,
      assists: 4,
      shots: 71,
      penaltyGoals: 1,
      penaltiesTaken: 2,
      freeKickGoals: 0,
      freeKickShots: 2,
      goalsFromInsideTheBox: 8,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 48,
      shotsFromOutsideTheBox: 23,
      headedGoals: 0,
      leftFootGoals: 5,
      rightFootGoals: 4,
      bigChances: 15,
      bigChancesCreated: 9,
      bigChancesMissed: 9,
      shotsOnTarget: 28,
      shotsOffTarget: 23,
      blockedScoringAttempt: 20,
      successfulDribbles: 17,
      dribbleAttempts: 55,
      corners: 34,
      hitWoodwork: 3,
      fastBreaks: 3,
      fastBreakGoals: 1,
      fastBreakShots: 3,
      averageBallPossession: 60.333333333333,
      totalPasses: 1820,
      accuratePasses: 1609,
      accuratePassesPercentage: 88.406593406593,
      totalOwnHalfPasses: 664,
      accurateOwnHalfPasses: 616,
      accurateOwnHalfPassesPercentage: 92.771084337349,
      totalOppositionHalfPasses: 1226,
      accurateOppositionHalfPasses: 1018,
      accurateOppositionHalfPassesPercentage: 83.034257748777,
      totalLongBalls: 97,
      accurateLongBalls: 62,
      accurateLongBallsPercentage: 63.917525773196,
      totalCrosses: 70,
      accurateCrosses: 25,
      accurateCrossesPercentage: 35.714285714286,
      cleanSheets: 0,
      tackles: 42,
      interceptions: 16,
      saves: 10,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 0,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 42,
      clearancesOffLine: 0,
      lastManTackles: 0,
      totalDuels: 250,
      duelsWon: 126,
      duelsWonPercentage: 50.4,
      totalGroundDuels: 189,
      groundDuelsWon: 86,
      groundDuelsWonPercentage: 45.502645502645,
      totalAerialDuels: 61,
      aerialDuelsWon: 40,
      aerialDuelsWonPercentage: 65.573770491803,
      possessionLost: 373,
      offsides: 1,
      fouls: 24,
      yellowCards: 5,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.1644444444444,
      accurateFinalThirdPassesAgainst: 221,
      accurateOppositionHalfPassesAgainst: 465,
      accurateOwnHalfPassesAgainst: 552,
      accuratePassesAgainst: 1006,
      bigChancesAgainst: 6,
      bigChancesCreatedAgainst: 5,
      bigChancesMissedAgainst: 2,
      clearancesAgainst: 92,
      cornersAgainst: 8,
      crossesSuccessfulAgainst: 11,
      crossesTotalAgainst: 40,
      dribbleAttemptsTotalAgainst: 31,
      dribbleAttemptsWonAgainst: 10,
      errorsLeadingToGoalAgainst: 2,
      errorsLeadingToShotAgainst: 1,
      hitWoodworkAgainst: 0,
      interceptionsAgainst: 36,
      keyPassesAgainst: 28,
      longBallsSuccessfulAgainst: 60,
      longBallsTotalAgainst: 139,
      offsidesAgainst: 9,
      redCardsAgainst: 0,
      shotsAgainst: 37,
      shotsBlockedAgainst: 12,
      shotsFromInsideTheBoxAgainst: 24,
      shotsFromOutsideTheBoxAgainst: 13,
      shotsOffTargetAgainst: 9,
      shotsOnTargetAgainst: 16,
      blockedScoringAttemptAgainst: 12,
      tacklesAgainst: 71,
      totalFinalThirdPassesAgainst: 295,
      oppositionHalfPassesTotalAgainst: 627,
      ownHalfPassesTotalAgainst: 619,
      totalPassesAgainst: 1206,
      yellowCardsAgainst: 4,
      throwIns: 38,
      goalKicks: 14,
      ballRecovery: 147,
      freeKicks: 28,
      id: 25071,
      matches: 3,
      awardedMatches: 0,
    },
  },
  2817: {
    statistics: {
      goalsScored: 17,
      goalsConceded: 4,
      ownGoals: 0,
      assists: 12,
      shots: 96,
      penaltyGoals: 1,
      penaltiesTaken: 1,
      freeKickGoals: 0,
      freeKickShots: 3,
      goalsFromInsideTheBox: 16,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 62,
      shotsFromOutsideTheBox: 34,
      headedGoals: 0,
      leftFootGoals: 11,
      rightFootGoals: 6,
      bigChances: 25,
      bigChancesCreated: 21,
      bigChancesMissed: 14,
      shotsOnTarget: 36,
      shotsOffTarget: 33,
      blockedScoringAttempt: 27,
      successfulDribbles: 60,
      dribbleAttempts: 111,
      corners: 35,
      hitWoodwork: 6,
      fastBreaks: 11,
      fastBreakGoals: 2,
      fastBreakShots: 9,
      averageBallPossession: 63.8,
      totalPasses: 2744,
      accuratePasses: 2399,
      accuratePassesPercentage: 87.427113702624,
      totalOwnHalfPasses: 1254,
      accurateOwnHalfPasses: 1174,
      accurateOwnHalfPassesPercentage: 93.620414673046,
      totalOppositionHalfPasses: 1572,
      accurateOppositionHalfPasses: 1249,
      accurateOppositionHalfPassesPercentage: 79.452926208651,
      totalLongBalls: 150,
      accurateLongBalls: 98,
      accurateLongBallsPercentage: 65.333333333333,
      totalCrosses: 82,
      accurateCrosses: 24,
      accurateCrossesPercentage: 29.268292682927,
      cleanSheets: 1,
      tackles: 74,
      interceptions: 17,
      saves: 9,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 2,
      penaltiesCommited: 1,
      penaltyGoalsConceded: 1,
      clearances: 62,
      clearancesOffLine: 1,
      lastManTackles: 0,
      totalDuels: 445,
      duelsWon: 243,
      duelsWonPercentage: 54.606741573034,
      totalGroundDuels: 363,
      groundDuelsWon: 200,
      groundDuelsWonPercentage: 55.096418732782,
      totalAerialDuels: 82,
      aerialDuelsWon: 43,
      aerialDuelsWonPercentage: 52.439024390244,
      possessionLost: 574,
      offsides: 8,
      fouls: 45,
      yellowCards: 10,
      yellowRedCards: 0,
      redCards: 1,
      avgRating: 7.1986486486487,
      accurateFinalThirdPassesAgainst: 239,
      accurateOppositionHalfPassesAgainst: 487,
      accurateOwnHalfPassesAgainst: 746,
      accuratePassesAgainst: 1216,
      bigChancesAgainst: 7,
      bigChancesCreatedAgainst: 6,
      bigChancesMissedAgainst: 4,
      clearancesAgainst: 107,
      cornersAgainst: 17,
      crossesSuccessfulAgainst: 17,
      crossesTotalAgainst: 72,
      dribbleAttemptsTotalAgainst: 65,
      dribbleAttemptsWonAgainst: 31,
      errorsLeadingToGoalAgainst: 1,
      errorsLeadingToShotAgainst: 2,
      hitWoodworkAgainst: 0,
      interceptionsAgainst: 46,
      keyPassesAgainst: 27,
      longBallsSuccessfulAgainst: 122,
      longBallsTotalAgainst: 253,
      offsidesAgainst: 27,
      redCardsAgainst: 0,
      shotsAgainst: 35,
      shotsBlockedAgainst: 8,
      shotsFromInsideTheBoxAgainst: 25,
      shotsFromOutsideTheBoxAgainst: 10,
      shotsOffTargetAgainst: 14,
      shotsOnTargetAgainst: 13,
      blockedScoringAttemptAgainst: 8,
      tacklesAgainst: 89,
      totalFinalThirdPassesAgainst: 366,
      oppositionHalfPassesTotalAgainst: 733,
      ownHalfPassesTotalAgainst: 856,
      totalPassesAgainst: 1517,
      yellowCardsAgainst: 16,
      throwIns: 94,
      goalKicks: 23,
      ballRecovery: 231,
      freeKicks: 66,
      id: 24710,
      matches: 5,
      awardedMatches: 0,
    },
  },
  2836: {
    statistics: {
      goalsScored: 9,
      goalsConceded: 2,
      ownGoals: 1,
      assists: 7,
      shots: 68,
      penaltyGoals: 0,
      penaltiesTaken: 0,
      freeKickGoals: 1,
      freeKickShots: 1,
      goalsFromInsideTheBox: 7,
      goalsFromOutsideTheBox: 2,
      shotsFromInsideTheBox: 52,
      shotsFromOutsideTheBox: 16,
      headedGoals: 1,
      leftFootGoals: 3,
      rightFootGoals: 5,
      bigChances: 17,
      bigChancesCreated: 12,
      bigChancesMissed: 11,
      shotsOnTarget: 23,
      shotsOffTarget: 29,
      blockedScoringAttempt: 16,
      successfulDribbles: 35,
      dribbleAttempts: 60,
      corners: 22,
      hitWoodwork: 3,
      fastBreaks: 9,
      fastBreakGoals: 3,
      fastBreakShots: 7,
      averageBallPossession: 51.8,
      totalPasses: 2688,
      accuratePasses: 2323,
      accuratePassesPercentage: 86.421130952381,
      totalOwnHalfPasses: 1392,
      accurateOwnHalfPasses: 1272,
      accurateOwnHalfPassesPercentage: 91.379310344828,
      totalOppositionHalfPasses: 1383,
      accurateOppositionHalfPasses: 1084,
      accurateOppositionHalfPassesPercentage: 78.380332610268,
      totalLongBalls: 210,
      accurateLongBalls: 119,
      accurateLongBallsPercentage: 56.666666666667,
      totalCrosses: 87,
      accurateCrosses: 33,
      accurateCrossesPercentage: 37.931034482759,
      cleanSheets: 4,
      tackles: 81,
      interceptions: 34,
      saves: 9,
      errorsLeadingToGoal: 1,
      errorsLeadingToShot: 3,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 96,
      clearancesOffLine: 0,
      lastManTackles: 0,
      totalDuels: 408,
      duelsWon: 216,
      duelsWonPercentage: 52.941176470588,
      totalGroundDuels: 306,
      groundDuelsWon: 159,
      groundDuelsWonPercentage: 51.960784313725,
      totalAerialDuels: 102,
      aerialDuelsWon: 57,
      aerialDuelsWonPercentage: 55.882352941176,
      possessionLost: 571,
      offsides: 13,
      fouls: 48,
      yellowCards: 6,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.03,
      accurateFinalThirdPassesAgainst: 561,
      accurateOppositionHalfPassesAgainst: 1267,
      accurateOwnHalfPassesAgainst: 911,
      accuratePassesAgainst: 2163,
      bigChancesAgainst: 1,
      bigChancesCreatedAgainst: 1,
      bigChancesMissedAgainst: 1,
      clearancesAgainst: 93,
      cornersAgainst: 19,
      crossesSuccessfulAgainst: 15,
      crossesTotalAgainst: 89,
      dribbleAttemptsTotalAgainst: 93,
      dribbleAttemptsWonAgainst: 47,
      errorsLeadingToGoalAgainst: 1,
      errorsLeadingToShotAgainst: 5,
      hitWoodworkAgainst: 1,
      interceptionsAgainst: 34,
      keyPassesAgainst: 24,
      longBallsSuccessfulAgainst: 112,
      longBallsTotalAgainst: 223,
      offsidesAgainst: 7,
      redCardsAgainst: 0,
      shotsAgainst: 43,
      shotsBlockedAgainst: 11,
      shotsFromInsideTheBoxAgainst: 21,
      shotsFromOutsideTheBoxAgainst: 22,
      shotsOffTargetAgainst: 22,
      shotsOnTargetAgainst: 10,
      blockedScoringAttemptAgainst: 11,
      tacklesAgainst: 60,
      totalFinalThirdPassesAgainst: 739,
      oppositionHalfPassesTotalAgainst: 1576,
      ownHalfPassesTotalAgainst: 1012,
      totalPassesAgainst: 2499,
      yellowCardsAgainst: 11,
      throwIns: 103,
      goalKicks: 42,
      ballRecovery: 229,
      freeKicks: 44,
      id: 24902,
      matches: 5,
      awardedMatches: 0,
    },
  },
  35: {
    statistics: {
      goalsScored: 5,
      goalsConceded: 5,
      ownGoals: 0,
      assists: 5,
      shots: 53,
      penaltyGoals: 0,
      penaltiesTaken: 0,
      freeKickGoals: 0,
      freeKickShots: 0,
      goalsFromInsideTheBox: 4,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 31,
      shotsFromOutsideTheBox: 22,
      headedGoals: 1,
      leftFootGoals: 2,
      rightFootGoals: 2,
      bigChances: 14,
      bigChancesCreated: 13,
      bigChancesMissed: 12,
      shotsOnTarget: 22,
      shotsOffTarget: 20,
      blockedScoringAttempt: 11,
      successfulDribbles: 40,
      dribbleAttempts: 80,
      corners: 23,
      hitWoodwork: 0,
      fastBreaks: 3,
      fastBreakGoals: 0,
      fastBreakShots: 3,
      averageBallPossession: 54,
      totalPasses: 2111,
      accuratePasses: 1831,
      accuratePassesPercentage: 86.736144007579,
      totalOwnHalfPasses: 1137,
      accurateOwnHalfPasses: 1043,
      accurateOwnHalfPassesPercentage: 91.732629727353,
      totalOppositionHalfPasses: 1032,
      accurateOppositionHalfPasses: 802,
      accurateOppositionHalfPassesPercentage: 77.713178294574,
      totalLongBalls: 103,
      accurateLongBalls: 58,
      accurateLongBallsPercentage: 56.31067961165,
      totalCrosses: 58,
      accurateCrosses: 14,
      accurateCrossesPercentage: 24.137931034483,
      cleanSheets: 2,
      tackles: 94,
      interceptions: 50,
      saves: 7,
      errorsLeadingToGoal: 3,
      errorsLeadingToShot: 1,
      penaltiesCommited: 1,
      penaltyGoalsConceded: 0,
      clearances: 51,
      clearancesOffLine: 2,
      lastManTackles: 1,
      totalDuels: 404,
      duelsWon: 207,
      duelsWonPercentage: 51.237623762376,
      totalGroundDuels: 325,
      groundDuelsWon: 170,
      groundDuelsWonPercentage: 52.307692307692,
      totalAerialDuels: 79,
      aerialDuelsWon: 37,
      aerialDuelsWonPercentage: 46.835443037975,
      possessionLost: 479,
      offsides: 9,
      fouls: 46,
      yellowCards: 12,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 6.9222222222222,
      accurateFinalThirdPassesAgainst: 292,
      accurateOppositionHalfPassesAgainst: 627,
      accurateOwnHalfPassesAgainst: 914,
      accuratePassesAgainst: 1525,
      bigChancesAgainst: 11,
      bigChancesCreatedAgainst: 7,
      bigChancesMissedAgainst: 6,
      clearancesAgainst: 73,
      cornersAgainst: 14,
      crossesSuccessfulAgainst: 16,
      crossesTotalAgainst: 46,
      dribbleAttemptsTotalAgainst: 80,
      dribbleAttemptsWonAgainst: 27,
      errorsLeadingToGoalAgainst: 0,
      errorsLeadingToShotAgainst: 2,
      hitWoodworkAgainst: 1,
      interceptionsAgainst: 37,
      keyPassesAgainst: 34,
      longBallsSuccessfulAgainst: 73,
      longBallsTotalAgainst: 152,
      offsidesAgainst: 3,
      redCardsAgainst: 1,
      shotsAgainst: 41,
      shotsBlockedAgainst: 9,
      shotsFromInsideTheBoxAgainst: 32,
      shotsFromOutsideTheBoxAgainst: 9,
      shotsOffTargetAgainst: 18,
      shotsOnTargetAgainst: 14,
      blockedScoringAttemptAgainst: 9,
      tacklesAgainst: 86,
      totalFinalThirdPassesAgainst: 417,
      oppositionHalfPassesTotalAgainst: 846,
      ownHalfPassesTotalAgainst: 1005,
      totalPassesAgainst: 1805,
      yellowCardsAgainst: 6,
      throwIns: 72,
      goalKicks: 21,
      ballRecovery: 231,
      freeKicks: 36,
      id: 24549,
      matches: 4,
      awardedMatches: 0,
    },
  },
  2687: {
    statistics: {
      goalsScored: 6,
      goalsConceded: 0,
      ownGoals: 0,
      assists: 4,
      shots: 44,
      penaltyGoals: 1,
      penaltiesTaken: 1,
      freeKickGoals: 0,
      freeKickShots: 2,
      goalsFromInsideTheBox: 5,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 32,
      shotsFromOutsideTheBox: 12,
      headedGoals: 1,
      leftFootGoals: 4,
      rightFootGoals: 1,
      bigChances: 5,
      bigChancesCreated: 3,
      bigChancesMissed: 4,
      shotsOnTarget: 16,
      shotsOffTarget: 17,
      blockedScoringAttempt: 11,
      successfulDribbles: 29,
      dribbleAttempts: 62,
      corners: 18,
      hitWoodwork: 2,
      fastBreaks: 5,
      fastBreakGoals: 2,
      fastBreakShots: 3,
      averageBallPossession: 58.5,
      totalPasses: 2271,
      accuratePasses: 2049,
      accuratePassesPercentage: 90.224570673712,
      totalOwnHalfPasses: 1340,
      accurateOwnHalfPasses: 1264,
      accurateOwnHalfPassesPercentage: 94.328358208955,
      totalOppositionHalfPasses: 987,
      accurateOppositionHalfPasses: 801,
      accurateOppositionHalfPassesPercentage: 81.155015197568,
      totalLongBalls: 125,
      accurateLongBalls: 82,
      accurateLongBallsPercentage: 65.6,
      totalCrosses: 56,
      accurateCrosses: 16,
      accurateCrossesPercentage: 28.571428571429,
      cleanSheets: 4,
      tackles: 65,
      interceptions: 20,
      saves: 5,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 1,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 51,
      clearancesOffLine: 0,
      lastManTackles: 0,
      totalDuels: 311,
      duelsWon: 176,
      duelsWonPercentage: 56.591639871383,
      totalGroundDuels: 249,
      groundDuelsWon: 135,
      groundDuelsWonPercentage: 54.21686746988,
      totalAerialDuels: 62,
      aerialDuelsWon: 41,
      aerialDuelsWonPercentage: 66.129032258065,
      possessionLost: 402,
      offsides: 8,
      fouls: 40,
      yellowCards: 5,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.0360655737705,
      accurateFinalThirdPassesAgainst: 288,
      accurateOppositionHalfPassesAgainst: 675,
      accurateOwnHalfPassesAgainst: 694,
      accuratePassesAgainst: 1363,
      bigChancesAgainst: 2,
      bigChancesCreatedAgainst: 2,
      bigChancesMissedAgainst: 2,
      clearancesAgainst: 59,
      cornersAgainst: 12,
      crossesSuccessfulAgainst: 6,
      crossesTotalAgainst: 58,
      dribbleAttemptsTotalAgainst: 50,
      dribbleAttemptsWonAgainst: 17,
      errorsLeadingToGoalAgainst: 1,
      errorsLeadingToShotAgainst: 2,
      hitWoodworkAgainst: 0,
      interceptionsAgainst: 22,
      keyPassesAgainst: 18,
      longBallsSuccessfulAgainst: 59,
      longBallsTotalAgainst: 139,
      offsidesAgainst: 2,
      redCardsAgainst: 0,
      shotsAgainst: 25,
      shotsBlockedAgainst: 13,
      shotsFromInsideTheBoxAgainst: 13,
      shotsFromOutsideTheBoxAgainst: 12,
      shotsOffTargetAgainst: 7,
      shotsOnTargetAgainst: 5,
      blockedScoringAttemptAgainst: 13,
      tacklesAgainst: 59,
      totalFinalThirdPassesAgainst: 383,
      oppositionHalfPassesTotalAgainst: 886,
      ownHalfPassesTotalAgainst: 768,
      totalPassesAgainst: 1596,
      yellowCardsAgainst: 9,
      throwIns: 62,
      goalKicks: 22,
      ballRecovery: 175,
      freeKicks: 42,
      id: 24895,
      matches: 4,
      awardedMatches: 0,
    },
  },
  2692: {
    statistics: {
      goalsScored: 9,
      goalsConceded: 6,
      ownGoals: 1,
      assists: 6,
      shots: 65,
      penaltyGoals: 2,
      penaltiesTaken: 2,
      freeKickGoals: 0,
      freeKickShots: 1,
      goalsFromInsideTheBox: 9,
      goalsFromOutsideTheBox: 0,
      shotsFromInsideTheBox: 39,
      shotsFromOutsideTheBox: 26,
      headedGoals: 2,
      leftFootGoals: 1,
      rightFootGoals: 6,
      bigChances: 12,
      bigChancesCreated: 8,
      bigChancesMissed: 7,
      shotsOnTarget: 23,
      shotsOffTarget: 24,
      blockedScoringAttempt: 18,
      successfulDribbles: 29,
      dribbleAttempts: 58,
      corners: 31,
      hitWoodwork: 1,
      fastBreaks: 2,
      fastBreakGoals: 0,
      fastBreakShots: 2,
      averageBallPossession: 59.25,
      totalPasses: 2132,
      accuratePasses: 1921,
      accuratePassesPercentage: 90.103189493433,
      totalOwnHalfPasses: 1040,
      accurateOwnHalfPasses: 979,
      accurateOwnHalfPassesPercentage: 94.134615384615,
      totalOppositionHalfPasses: 1186,
      accurateOppositionHalfPasses: 965,
      accurateOppositionHalfPassesPercentage: 81.365935919056,
      totalLongBalls: 92,
      accurateLongBalls: 52,
      accurateLongBallsPercentage: 56.521739130435,
      totalCrosses: 94,
      accurateCrosses: 23,
      accurateCrossesPercentage: 24.468085106383,
      cleanSheets: 1,
      tackles: 56,
      interceptions: 29,
      saves: 8,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 1,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 51,
      clearancesOffLine: 1,
      lastManTackles: 0,
      totalDuels: 318,
      duelsWon: 161,
      duelsWonPercentage: 50.62893081761,
      totalGroundDuels: 248,
      groundDuelsWon: 123,
      groundDuelsWonPercentage: 49.596774193548,
      totalAerialDuels: 70,
      aerialDuelsWon: 38,
      aerialDuelsWonPercentage: 54.285714285714,
      possessionLost: 388,
      offsides: 2,
      fouls: 44,
      yellowCards: 9,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 6.9870967741935,
      accurateFinalThirdPassesAgainst: 197,
      accurateOppositionHalfPassesAgainst: 417,
      accurateOwnHalfPassesAgainst: 857,
      accuratePassesAgainst: 1267,
      bigChancesAgainst: 11,
      bigChancesCreatedAgainst: 11,
      bigChancesMissedAgainst: 6,
      clearancesAgainst: 88,
      cornersAgainst: 11,
      crossesSuccessfulAgainst: 7,
      crossesTotalAgainst: 46,
      dribbleAttemptsTotalAgainst: 50,
      dribbleAttemptsWonAgainst: 29,
      errorsLeadingToGoalAgainst: 1,
      errorsLeadingToShotAgainst: 1,
      hitWoodworkAgainst: 1,
      interceptionsAgainst: 24,
      keyPassesAgainst: 25,
      longBallsSuccessfulAgainst: 86,
      longBallsTotalAgainst: 184,
      offsidesAgainst: 10,
      redCardsAgainst: 1,
      shotsAgainst: 29,
      shotsBlockedAgainst: 5,
      shotsFromInsideTheBoxAgainst: 17,
      shotsFromOutsideTheBoxAgainst: 12,
      shotsOffTargetAgainst: 10,
      shotsOnTargetAgainst: 14,
      blockedScoringAttemptAgainst: 5,
      tacklesAgainst: 56,
      totalFinalThirdPassesAgainst: 285,
      oppositionHalfPassesTotalAgainst: 602,
      ownHalfPassesTotalAgainst: 921,
      totalPassesAgainst: 1477,
      yellowCardsAgainst: 11,
      throwIns: 53,
      goalKicks: 17,
      ballRecovery: 177,
      freeKicks: 39,
      id: 24705,
      matches: 4,
      awardedMatches: 0,
    },
  },
  2829: {
    statistics: {
      goalsScored: 9,
      goalsConceded: 2,
      ownGoals: 0,
      assists: 5,
      shots: 93,
      penaltyGoals: 4,
      penaltiesTaken: 4,
      freeKickGoals: 1,
      freeKickShots: 3,
      goalsFromInsideTheBox: 8,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 65,
      shotsFromOutsideTheBox: 28,
      headedGoals: 0,
      leftFootGoals: 2,
      rightFootGoals: 7,
      bigChances: 12,
      bigChancesCreated: 7,
      bigChancesMissed: 6,
      shotsOnTarget: 35,
      shotsOffTarget: 26,
      blockedScoringAttempt: 32,
      successfulDribbles: 65,
      dribbleAttempts: 119,
      corners: 31,
      hitWoodwork: 1,
      fastBreaks: 8,
      fastBreakGoals: 0,
      fastBreakShots: 8,
      averageBallPossession: 59.6,
      totalPasses: 2964,
      accuratePasses: 2652,
      accuratePassesPercentage: 89.473684210526,
      totalOwnHalfPasses: 1139,
      accurateOwnHalfPasses: 1068,
      accurateOwnHalfPassesPercentage: 93.766461808604,
      totalOppositionHalfPasses: 1906,
      accurateOppositionHalfPasses: 1606,
      accurateOppositionHalfPassesPercentage: 84.260230849948,
      totalLongBalls: 182,
      accurateLongBalls: 122,
      accurateLongBallsPercentage: 67.032967032967,
      totalCrosses: 81,
      accurateCrosses: 22,
      accurateCrossesPercentage: 27.16049382716,
      cleanSheets: 3,
      tackles: 80,
      interceptions: 38,
      saves: 9,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 0,
      penaltiesCommited: 0,
      penaltyGoalsConceded: 0,
      clearances: 65,
      clearancesOffLine: 0,
      lastManTackles: 1,
      totalDuels: 474,
      duelsWon: 260,
      duelsWonPercentage: 54.852320675105,
      totalGroundDuels: 386,
      groundDuelsWon: 212,
      groundDuelsWonPercentage: 54.922279792746,
      totalAerialDuels: 88,
      aerialDuelsWon: 48,
      aerialDuelsWonPercentage: 54.545454545455,
      possessionLost: 562,
      offsides: 6,
      fouls: 47,
      yellowCards: 7,
      yellowRedCards: 0,
      redCards: 1,
      avgRating: 7.2581081081081,
      accurateFinalThirdPassesAgainst: 341,
      accurateOppositionHalfPassesAgainst: 738,
      accurateOwnHalfPassesAgainst: 945,
      accuratePassesAgainst: 1666,
      bigChancesAgainst: 7,
      bigChancesCreatedAgainst: 6,
      bigChancesMissedAgainst: 5,
      clearancesAgainst: 102,
      cornersAgainst: 24,
      crossesSuccessfulAgainst: 17,
      crossesTotalAgainst: 75,
      dribbleAttemptsTotalAgainst: 72,
      dribbleAttemptsWonAgainst: 35,
      errorsLeadingToGoalAgainst: 0,
      errorsLeadingToShotAgainst: 2,
      hitWoodworkAgainst: 3,
      interceptionsAgainst: 49,
      keyPassesAgainst: 39,
      longBallsSuccessfulAgainst: 91,
      longBallsTotalAgainst: 204,
      offsidesAgainst: 5,
      redCardsAgainst: 0,
      shotsAgainst: 49,
      shotsBlockedAgainst: 15,
      shotsFromInsideTheBoxAgainst: 33,
      shotsFromOutsideTheBoxAgainst: 16,
      shotsOffTargetAgainst: 23,
      shotsOnTargetAgainst: 11,
      blockedScoringAttemptAgainst: 15,
      tacklesAgainst: 97,
      totalFinalThirdPassesAgainst: 481,
      oppositionHalfPassesTotalAgainst: 1011,
      ownHalfPassesTotalAgainst: 1041,
      totalPassesAgainst: 1977,
      yellowCardsAgainst: 6,
      throwIns: 93,
      goalKicks: 32,
      ballRecovery: 225,
      freeKicks: 68,
      id: 24835,
      matches: 5,
      awardedMatches: 0,
    },
  },
  2697: {
    statistics: {
      goalsScored: 9,
      goalsConceded: 3,
      ownGoals: 0,
      assists: 4,
      shots: 57,
      penaltyGoals: 1,
      penaltiesTaken: 1,
      freeKickGoals: 0,
      freeKickShots: 2,
      goalsFromInsideTheBox: 7,
      goalsFromOutsideTheBox: 1,
      shotsFromInsideTheBox: 41,
      shotsFromOutsideTheBox: 16,
      headedGoals: 2,
      leftFootGoals: 1,
      rightFootGoals: 5,
      bigChances: 14,
      bigChancesCreated: 7,
      bigChancesMissed: 8,
      shotsOnTarget: 17,
      shotsOffTarget: 26,
      blockedScoringAttempt: 14,
      successfulDribbles: 9,
      dribbleAttempts: 33,
      corners: 25,
      hitWoodwork: 1,
      fastBreaks: 4,
      fastBreakGoals: 0,
      fastBreakShots: 4,
      averageBallPossession: 60.75,
      totalPasses: 2175,
      accuratePasses: 1943,
      accuratePassesPercentage: 89.333333333333,
      totalOwnHalfPasses: 1011,
      accurateOwnHalfPasses: 956,
      accurateOwnHalfPassesPercentage: 94.559841740851,
      totalOppositionHalfPasses: 1245,
      accurateOppositionHalfPasses: 1011,
      accurateOppositionHalfPassesPercentage: 81.204819277108,
      totalLongBalls: 110,
      accurateLongBalls: 58,
      accurateLongBallsPercentage: 52.727272727273,
      totalCrosses: 81,
      accurateCrosses: 24,
      accurateCrossesPercentage: 29.62962962963,
      cleanSheets: 2,
      tackles: 57,
      interceptions: 16,
      saves: 11,
      errorsLeadingToGoal: 0,
      errorsLeadingToShot: 1,
      penaltiesCommited: 1,
      penaltyGoalsConceded: 0,
      clearances: 62,
      clearancesOffLine: 0,
      lastManTackles: 0,
      totalDuels: 348,
      duelsWon: 176,
      duelsWonPercentage: 50.574712643678,
      totalGroundDuels: 232,
      groundDuelsWon: 112,
      groundDuelsWonPercentage: 48.275862068966,
      totalAerialDuels: 116,
      aerialDuelsWon: 64,
      aerialDuelsWonPercentage: 55.172413793103,
      possessionLost: 411,
      offsides: 17,
      fouls: 50,
      yellowCards: 4,
      yellowRedCards: 0,
      redCards: 0,
      avgRating: 7.0078125,
      accurateFinalThirdPassesAgainst: 287,
      accurateOppositionHalfPassesAgainst: 600,
      accurateOwnHalfPassesAgainst: 610,
      accuratePassesAgainst: 1197,
      bigChancesAgainst: 5,
      bigChancesCreatedAgainst: 1,
      bigChancesMissedAgainst: 3,
      clearancesAgainst: 83,
      cornersAgainst: 12,
      crossesSuccessfulAgainst: 13,
      crossesTotalAgainst: 62,
      dribbleAttemptsTotalAgainst: 49,
      dribbleAttemptsWonAgainst: 27,
      errorsLeadingToGoalAgainst: 1,
      errorsLeadingToShotAgainst: 2,
      hitWoodworkAgainst: 0,
      interceptionsAgainst: 32,
      keyPassesAgainst: 24,
      longBallsSuccessfulAgainst: 71,
      longBallsTotalAgainst: 166,
      offsidesAgainst: 2,
      redCardsAgainst: 0,
      shotsAgainst: 39,
      shotsBlockedAgainst: 8,
      shotsFromInsideTheBoxAgainst: 23,
      shotsFromOutsideTheBoxAgainst: 16,
      shotsOffTargetAgainst: 17,
      shotsOnTargetAgainst: 14,
      blockedScoringAttemptAgainst: 8,
      tacklesAgainst: 47,
      totalFinalThirdPassesAgainst: 372,
      oppositionHalfPassesTotalAgainst: 808,
      ownHalfPassesTotalAgainst: 668,
      totalPassesAgainst: 1414,
      yellowCardsAgainst: 6,
      throwIns: 74,
      goalKicks: 20,
      ballRecovery: 161,
      freeKicks: 48,
      id: 24669,
      matches: 4,
      awardedMatches: 0,
    },
  },
};
